import { LitElement, css, html } from 'lit'
import { alertIconNoFill } from '../assets/icons.js'

class alertTextIndicator extends LitElement {
  static properties = {
    text: { type: String },
    boxType: { type: String },
    iconType: { type: String },
  }

  constructor() {
    super()

    this.text = ''
    this.boxType = ''
    this.iconType = ''
  }

  render() {
    return html`
      <div class="slot-container ${this.iconType}">
        <div class="alert-box ${this.boxType}">
          ${alertIconNoFill}
          <p>${this.text}</p>
        </div>
        ${alertIconNoFill}<slot></slot>
      </div>
    `
  }

  static styles = [
    css`
      .slot-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
      }

      .alert-box {
        display: none;
        position: absolute;
        width: 150%;
        top: -40px;
        padding: 2px 8px 2px 8px;
        z-index: 1;
        justify-content: center;
        align-items: center;
        text-align: center;
        white-space: nowrap;
        border-radius: 5px;
        font-size: 12px;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
      }
      .alert-box > svg {
        fill: white;
      }

      .slot-container:hover .alert-box {
        display: flex;
        gap: 8px;
      }

      .success-icon > svg {
        fill: #37b478;
      }

      .success {
        background-color: #37b478;
        color: white;
      }

      .error-icon > svg {
        fill: #f2637e;
      }
      .error {
        background-color: #f2637e;
        color: white;
      }

      .warning-icon {
        fill: #f3b664;
      }
      .warning {
        background-color: #f3b664;
        color: white;
      }
    `,
  ]
}

customElements.define('alert-text-indicator', alertTextIndicator)
export default alertTextIndicator
